(function(window, angular){'use strict';

var ngModule = angular.module('pp.values.regex', []);

var leiRegex = /^[A-Z0-9]{18,18}[0-9]{2,2}$/;
ngModule.value('leiRegex', leiRegex);
})(window, window.angular);